export const messages = {
  en: {
    addComplaintType: {
      title: 'Add Complaint Type',
      typeName: 'Type Name',
      typeNamePlaceholder: 'Required, please enter type name',
      notifyWay: 'Notification Method',
      notifyWayPlaceholder: 'Required, please select notification method',
      appraiseReply: 'Evaluation Reply',
      appraiseReplyPlaceholder: 'Required, please select evaluation reply',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      selectStaff: 'Select Staff',
      sms: 'SMS',
      wechat: 'WeChat',
      workLicense: 'WeChat + Work License',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply'
    },
  },
  zh: {
    addComplaintType: {
      title: '添加投诉类型',
      typeName: '类型名称',
      typeNamePlaceholder: '必填，请填写类型名称',
      notifyWay: '通知方式',
      notifyWayPlaceholder: '必填，请选择通知方式',
      appraiseReply: '评价回复',
      appraiseReplyPlaceholder: '必填，请选择评价回复',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      selectStaff: '选择员工',
      sms: '短信',
      wechat: '微信',
      workLicense: '微信+员工工牌',
      autoReply: '自动回复',
manualReply: '人工回复'
    },
  },
  'zh-TW': {
    addComplaintType: {
      title: '添加投訴類型',
      typeName: '類型名稱',
      typeNamePlaceholder: '必填，請填寫類型名稱',
      notifyWay: '通知方式',
      notifyWayPlaceholder: '必填，請選擇通知方式',
      appraiseReply: '評價回復',
      appraiseReplyPlaceholder: '必填，請選擇評價回復',
      remark: '備註',
      remarkPlaceholder: '選填，請填寫備註',
      selectStaff: '選擇員工',
      sms: '短信',
      wechat: '微信',
      workLicense: '微信+員工工牌',
      autoReply: '自動回復',
      manualReply: '人工回復'
    },
  }
}